import { Link, useLocation } from "react-router-dom";
import "./style.css"
import { useSelector } from "react-redux";

function Nav() {
    const location = useLocation();
    const status = useSelector(state => state.profil.status);

    const isActif = (path) => {
        return location.pathname === `/home${path ? `/${path}` : ''}` ? "actif" : "";
    }

    const logout = () => {
        sessionStorage.removeItem('save_login');
        sessionStorage.removeItem('email');
        sessionStorage.removeItem('password');
        sessionStorage.removeItem('status');
        sessionStorage.removeItem('token');

        localStorage.removeItem('save_login');
        localStorage.removeItem('email');
        localStorage.removeItem('password');
        localStorage.removeItem('status');
        localStorage.removeItem('token');

        window.location.reload();
    }

    return (
        <nav>
            <ul>
                {status === 'admin' &&
                    <li className={isActif('wlist')}>
                        <Link to="wlist">Email autorisé</Link>
                    </li>
                }
                <li className={isActif('')}>
                    <Link to="">Rechercher</Link>
                </li>
                <li className={isActif('profil')}>
                    <Link to="profil">Mon profil</Link>
                </li>
                <li className={isActif('access')}>
                    <Link to="access">Access</Link>
                </li>
                <li className={isActif('meeting')}>
                    <Link to="meeting">Organiser une réunion</Link>
                </li>
                <li className={isActif('meeting')}>
                    <button onClick={() => logout()}>Se déconnecter</button>
                </li>
            </ul>
        </nav>
    )
}

export default Nav;